












import Vue from 'vue';
import {Link} from '@/lib/types';
import Navigation from '@/components/Navigation.vue';

export default Vue.extend({
    data() {
        return {
            links: [
                {text: 'Home', img: 'home', leads: '/'},
                {text: 'About', img: 'about', leads: 'about'},
                {text: 'Sandbox', img: 'sandbox', leads: 'sandbox'},
                {text: 'Admin', img: 'lock2', leads: 'admin'},
            ] as Link[],
            windowHeight: window.innerHeight,
        };
    },
    components: {
        Navigation,
    },
    methods: {
        checkAuth() {
            const li = this.links.findIndex((l) => l.leads === 'admin');
            if (!!Vue.$cookies.get('authenticated') && li > -1) {
                this.links[li].leads = 'management';
            } else if (li > -1) {
                this.links[li].leads = 'admin';
            } else {
                throw new Error('You need to have an admin link in your navigation!');
            }
        },
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.windowHeight = window.innerHeight;
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', () => {
            this.windowHeight = window.innerHeight;
        });
    },
});
